import { useTestCaseContext } from '@Context/TestCaseContext';
import { TestCaseProp } from '@Models/types';
import { MagnifyingGlass, SquaresFour, X } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';
import TestCase from './TestCase';
import Links from './Links';
import { parseLinks, parseTestCases } from '@Generator/history/PubColumn';

const TestRailHistory = () => {
  const [selectedTestCase, setSelectedTestCase] = useState<TestCaseProp | null>(
    null
  );
  const [search, setSearch] = useState('');
  const { selectedPublish } = useTestCaseContext();

  useEffect(() => {
    setSelectedTestCase(null);
  }, [selectedPublish]);

  if (!selectedPublish) {
    return <div></div>;
  }

  const tempTC = selectedPublish.test_cases;
  const tempTR = selectedPublish.push_result;
  const isTCString = typeof tempTC === 'string';
  const isTRString = typeof tempTR === 'string';
  const testcases = isTCString ? parseTestCases(tempTC) : tempTC;
  const testrail = isTRString ? parseLinks(tempTR) : tempTR;

  let total = 0;
  testcases.forEach((item) => {
    item.GeneratedTestCase.forEach(() => {
      total++;
    });
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clearSearch = () => {
    setSearch('');
  };

  return (
    <div className="flex h-full w-full flex-col md:flex-row">
      <div className="flex h-full flex-col border-b-2 p-4 md:w-1/3 md:border-r-2">
        <div className="flex flex-col gap-y-2">
          <label className="font-inter text-xs font-bold text-gray-500">
            {' '}
            Generated Test Cases{' '}
          </label>
        </div>
        <div className="mt-1 flex flex-row items-center gap-3 text-xl font-bold md:justify-between md:gap-0">
          <label>Test Cases</label>
          <label>{total}</label>
        </div>
        <div className="mt-2 flex flex-row items-center gap-x-2 rounded-md border px-4 py-2">
          <MagnifyingGlass size={20} weight="bold" />
          <input
            type="text"
            className="w-full border-gray-300 font-inter text-sm focus:outline-none"
            placeholder="Search Test Cases"
            value={search}
            onChange={handleSearch}
          />
          <X
            weight="bold"
            className="cursor-pointer hover:text-brandRed-500"
            onClick={clearSearch}
          />
        </div>
        <div className="custom-scroll flex h-0 flex-grow flex-col overflow-y-auto">
          {testcases.map((item, index) => {
            const filteredTestCases = item.GeneratedTestCase.filter(
              () =>
                item.reference_num
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                item.name.toLowerCase().includes(search.toLowerCase())
            );

            const showItem = filteredTestCases.length > 0;

            return (
              <div key={index} className="flex flex-col">
                {showItem && <div className="my-4 border"></div>}
                {showItem && (
                  <span className="flex flex-col items-start">
                    {item.reference_num && (
                      <label className="rounded-md bg-primary-500 px-2 py-1 text-xs text-white">
                        {item.reference_num}
                      </label>
                    )}
                    <label className="text-base font-medium md:text-lg">
                      {item.name}
                    </label>
                  </span>
                )}
                <div className="flex flex-col gap-y-1">
                  {filteredTestCases.map((tc, index) => (
                    <label
                      key={index}
                      onClick={() => setSelectedTestCase(tc)}
                      className="cursor-pointer px-2 py-0.5 text-xs hover:bg-primary-100"
                    >
                      {tc.title}
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex h-2/3 w-full flex-col md:h-full md:w-2/3">
        <div className="custom-scroll h-0 w-full flex-[2] flex-grow overflow-y-auto p-4 md:flex-[1]">
          <div className="flex flex-col gap-y-2">
            <label className="font-inter text-xs font-bold text-gray-500">
              {' '}
              TestRail Publication{' '}
            </label>
          </div>
          <Links links={testrail} />
        </div>
        <div className="flex h-0 flex-[1] flex-grow flex-col p-4 md:flex-[2]">
          <div className="flex flex-col gap-y-2">
            <label className="font-inter text-xs font-bold text-gray-500">
              {' '}
              Test Case Details{' '}
            </label>
          </div>
          {!selectedTestCase && (
            <div className="flex h-full w-full flex-col items-center justify-center">
              <SquaresFour size={200} className="text-gray-300" />
              <label className="font-semibold text-gray-500">
                {' '}
                Select a Test Case first{' '}
              </label>
            </div>
          )}
          {selectedTestCase && (
            <TestCase
              testcase={selectedTestCase}
              setSelectedTestCase={function (): void {
                throw new Error('Function not implemented.');
              }}
              isEditable={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TestRailHistory;
